import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams, results }: StateType) => ({
  searchType: queryParams.type,
  hasDecisionRef: results.hasDecisionRef,
  hasNoResults: results.totalHits === 0,
  isSearchLoading: results.searchLoading,
  hasError: !!results.error,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
